module.exports = __webpack_public_path__ + "images/48638bc90d60a01660ce82664003296b.jpg";